// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-slide .new_proItem {
  max-width: 285px;
  margin: 0 auto;
}
.swiper-slide .new_proItem .row .col-xl-3 {
  width: 100%;
  margin-bottom: 0px !important;
}
.swiper-slide .new_proItem .row .col-xl-3 .listing-block {
  height: 100% !important;
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .swiper-slide .new_proItem .row .col-xl-3 .listing-name {
    min-height: 20px !important;
    line-height: 17px !important;
  }
}
.swiper-slide .new_proItem .row .col-xl-3 .main_div.active {
  margin-right: 0px !important;
}
.swiper-slide .new_proItem .row .col-xl-3 .form-select {
  padding: 5px 10px;
}
.swiper-slide .new_proItem .row .col-xl-3 .listing-block {
  padding: 15px !important;
  display: flex;
  min-height: 187px;
  flex-direction: column;
  justify-content: space-between;
}
.swiper-slide .new_proItem .row .col-xl-3 .listing-bottom-right h6 {
  margin: 0px auto;
}
.swiper-slide .new_proItem .row .col-xl-3 .listing-top {
  margin-bottom: 14px !important;
}
.swiper-slide .new_proItem .row .col-xl-3 .listing-bottom-right.active {
  margin-left: 0px !important;
}
@media screen and (min-width: 1200px) {
  .swiper-slide .new_proItem .row .col-xl-3 .left_bottom_div {
    margin-left: 0px;
    margin-bottom: -8px;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1362px) {
  .swiper-slide .new_proItem .row .col-xl-3 .listing-block {
    padding: 10px !important;
    display: flex;
    min-height: 206px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1199.98px) {
  .swiper-slide .listing-name {
    min-height: 37px !important;
    line-height: 18px !important;
  }
  .swiper-slide .new_proItem .row .col-xl-3 .listing-bottom {
    margin-bottom: -10px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .swiper-slide .new_proItem .listing-bottom-right p {
    font-size: 14px !important;
  }
  .swiper-slide .new_proItem .listing-bottom-right p span {
    font-size: 13px !important;
  }
  .swiper-slide .new_proItem .listing-bottom-right h6 {
    font-size: 14px !important;
  }
  .swiper-slide .new_proItem .view-listing-btn {
    line-height: 16px !important;
  }
}
@media (min-width: 1101px) and (max-width: 1299.98px) {
  .swiper-slide .new_proItem .listing-bottom-right.active {
    position: relative;
    right: 10px;
    bottom: 10px;
  }
}
@media (min-width: 992px) and (max-width: 1030px) {
  .swiper-slide .new_proItem .row .col-xl-3 .listing-block {
    padding: 10px !important;
    min-height: 100%;
  }
}
@media (min-width: 992px) and (max-width: 1100px) {
  .swiper-slide .new_proItem .listing-bottom-right.active {
    position: relative;
    right: 10px;
    bottom: 10px;
  }
  .swiper-slide .new_proItem .row .col-xl-3 .form-select {
    padding: 5px !important;
  }
}
@media screen and (max-width: 992px) {
  .listing-bottom-right {
    margin-left: 0px;
  }
  .listing-bottom-right .listing-bottom-right h6 {
    font-size: 16px !important;
  }
}
.customArrow_customer {
  border-radius: 50%;
  padding: 10px;
}

.slider-container {
  width: 90% !important; /* Adjust the width as needed */
  margin: 0 auto !important; /* Center the slider */
}

@media screen and (max-width: 492px) {
  .responsive_class_width_banner {
    width: 80%;
    margin-left: 35px;
  }
  .carousel-button.next-button {
    right: 46px;
  }
  .carousel-button.prev-button {
    left: 37px;
  }
}
@media screen and (max-width: 480px) {
  .responsive_class_width_banner {
    width: 80%;
    margin-left: 35px;
  }
  .carousel-button.next-button {
    right: 38px;
  }
  .carousel-button.prev-button {
    left: 37px;
  }
}
.custom_discount_promoBrand:hover {
  box-shadow: 0 1px 5px rgb(7, 7, 7);
  font-weight: bold;
}

.carousel_slide.hover-effect {
  transition: all 0.3s ease-in-out;
  border: 2px solid transparent;
}

.carousel_slide.hover-effect:hover {
  transform: scale(1.015);
}

.hover-effect_sp:hover {
  border-color: rgb(7, 7, 7);
  box-shadow: 0 0px 5px rgb(7, 7, 7);
  border-radius: 20px;
  transition: box-shadow 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/pages/PromotionalSlider.scss"],"names":[],"mappings":"AAEI;EACI,gBAAA;EACA,cAAA;AADR;AAGY;EACI,WAAA;EACA,6BAAA;AADhB;AAGgB;EACI,uBAAA;AADpB;AAIgB;EACI;IACI,2BAAA;IACA,4BAAA;EAFtB;AACF;AAMgB;EACI,4BAAA;AAJpB;AAQgB;EACI,iBAAA;AANpB;AASgB;EACI,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;AAPpB;AAUgB;EACI,gBAAA;AARpB;AAWgB;EACI,8BAAA;AATpB;AAYgB;EACI,2BAAA;AAVpB;AAegB;EAEI;IACI,gBAAA;IACA,mBAAA;EAdtB;AACF;;AAyBA;EACI;IACI,wBAAA;IACA,aAAA;IACA,iBAAA;EAtBN;AACF;AA2BA;EAEQ;IACI,2BAAA;IACA,4BAAA;EA1BV;EA8BE;IACI,oBAAA;EA5BN;AACF;AAgCA;EAKgB;IACI,0BAAA;EAlClB;EAoCkB;IACI,0BAAA;EAlCtB;EAsCc;IACI,0BAAA;EApClB;EAwCU;IACI,4BAAA;EAtCd;AACF;AA6CA;EAKY;IACI,kBAAA;IACA,WAAA;IACA,YAAA;EA/Cd;AACF;AAoDA;EAIgB;IACI,wBAAA;IACA,gBAAA;EArDlB;AACF;AA4DA;EAKY;IACI,kBAAA;IACA,WAAA;IACA,YAAA;EA9Dd;EAmEkB;IACI,uBAAA;EAjEtB;AACF;AAyEA;EACI;IACI,gBAAA;EAvEN;EAwEM;IACI,0BAAA;EAtEV;AACF;AA4EA;EACI,kBAAA;EACA,aAAA;AA1EJ;;AA8EA;EACE,qBAAA,EAAA,+BAAA;EACA,yBAAA,EAAA,sBAAA;AA3EF;;AA8EA;EACI;IACI,UAAA;IACA,iBAAA;EA3EN;EA6EE;IACI,WAAA;EA3EN;EA6EE;IACI,UAAA;EA3EN;AACF;AA6EA;EACI;IACI,UAAA;IACA,iBAAA;EA3EN;EA6EE;IACI,WAAA;EA3EN;EA6EE;IACI,UAAA;EA3EN;AACF;AA8EA;EACI,kCAAA;EACA,iBAAA;AA5EJ;;AA8EA;EACI,gCAAA;EACA,6BAAA;AA3EJ;;AA8EE;EACE,uBAAA;AA3EJ;;AA6EE;EACE,0BAAA;EACA,kCAAA;EACA,mBAAA;EACA,gCAAA;AA1EJ","sourcesContent":[".swiper-slide {\n\n    .new_proItem {\n        max-width: 285px;\n        margin: 0 auto;\n        .row {\n            .col-xl-3 {\n                width: 100%;\n                margin-bottom: 0px !important;\n\n                .listing-block {\n                    height: 100% !important;\n                }\n\n                @media (min-width:1200px) and (max-width:1300px) {\n                    .listing-name {\n                        min-height: 20px !important;\n                        line-height: 17px !important;\n                    }\n\n                }\n\n                .main_div.active {\n                    margin-right: 0px !important;\n                }\n\n\n                .form-select {\n                    padding: 5px 10px;\n                }\n\n                .listing-block {\n                    padding: 15px !important;\n                    display: flex;\n                    min-height: 187px;\n                    flex-direction: column;\n                    justify-content: space-between;\n                }\n\n                .listing-bottom-right h6 {\n                    margin: 0px auto;\n                }\n\n                .listing-top {\n                    margin-bottom: 14px !important;\n                }\n\n                .listing-bottom-right.active {\n                    margin-left: 0px !important;\n\n                }\n\n\n                @media screen and (min-width: 1200px) {\n\n                    .left_bottom_div {\n                        margin-left: 0px;\n                        margin-bottom: -8px;\n                    }\n                }\n\n\n\n\n            }\n        }\n    }\n}\n\n@media screen and (min-width: 1200px) and (max-width: 1362px) {\n    .swiper-slide .new_proItem .row .col-xl-3 .listing-block {\n        padding: 10px !important;\n        display: flex;\n        min-height: 206px;\n    }\n\n\n}\n\n@media screen and (min-width: 992px) and (max-width: 1199.98px) {\n    .swiper-slide {\n        .listing-name {\n            min-height: 37px !important;\n            line-height: 18px !important;\n        }\n    }\n\n    .swiper-slide .new_proItem .row .col-xl-3 .listing-bottom {\n        margin-bottom: -10px;\n    }\n}\n\n\n@media (min-width:992px) and (max-width:1200px) {\n    .swiper-slide {\n\n        .new_proItem {\n            .listing-bottom-right {\n                p {\n                    font-size: 14px !important;\n\n                    span {\n                        font-size: 13px !important;\n                    }\n                }\n\n                h6 {\n                    font-size: 14px !important;\n                }\n            }\n\n            .view-listing-btn {\n                line-height: 16px !important;\n            }\n        }\n    }\n\n\n}\n\n@media (min-width:1101px) and (max-width:1299.98px) {\n\n    .swiper-slide {\n\n        .new_proItem {\n            .listing-bottom-right.active {\n                position: relative;\n                right: 10px;\n                bottom: 10px;\n            }\n        }\n    }\n}\n\n@media (min-width:992px) and (max-width:1030px) {\n    .swiper-slide {\n        .new_proItem {\n            .row .col-xl-3 {\n                .listing-block {\n                    padding: 10px !important;\n                    min-height: 100%;\n                }\n\n            }\n        }\n    }\n}\n\n@media (min-width:992px) and (max-width:1100px) {\n\n    .swiper-slide {\n\n        .new_proItem {\n            .listing-bottom-right.active {\n                position: relative;\n                right: 10px;\n                bottom: 10px;\n            }\n\n            .row {\n                .col-xl-3 {\n                    .form-select {\n                        padding: 5px !important;\n                    }\n\n                }\n            }\n        }\n    }\n}\n\n@media screen and (max-width:992px) {\n    .listing-bottom-right {\n        margin-left: 0px;\n        .listing-bottom-right h6 {\n            font-size: 16px !important;\n        }\n    }\n}\n\n\n\n.customArrow_customer{\n    border-radius: 50%;\n    padding: 10px;\n    // background-color: white;\n}\n\n.slider-container {\n  width: 90% !important; /* Adjust the width as needed */\n  margin: 0 auto !important; /* Center the slider */\n}\n\n@media screen and (max-width: 492px) {\n    .responsive_class_width_banner{\n        width: 80%;\n        margin-left: 35px;\n    }\n    .carousel-button.next-button {\n        right: 46px;\n    }\n    .carousel-button.prev-button {\n        left: 37px;\n    }\n}\n@media screen and (max-width: 480px) {\n    .responsive_class_width_banner{\n        width: 80%;\n        margin-left: 35px;\n    }\n    .carousel-button.next-button {\n        right: 38px;\n    }\n    .carousel-button.prev-button {\n        left: 37px;\n    }\n}\n\n.custom_discount_promoBrand:hover{\n    box-shadow: 0 1px 5px rgb(7, 7, 7);\n    font-weight: bold;\n}\n.carousel_slide.hover-effect {\n    transition: all 0.3s ease-in-out;\n    border: 2px solid transparent;\n  }\n  \n  .carousel_slide.hover-effect:hover {\n    transform: scale(1.015);\n  }\n  .hover-effect_sp:hover {\n    border-color: rgb(7, 7, 7);\n    box-shadow: 0 0px 5px rgb(7, 7, 7);\n    border-radius: 20px;\n    transition: box-shadow 0.3s ease;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
